import React from 'react';
import { CrosshairFrame } from './Crosshair';

interface CardProps {
  children: React.ReactNode;
  title?: string;
  subtitle?: string;
  headerActions?: React.ReactNode;
}

const Card: React.FC<CardProps> = ({ children, title, subtitle, headerActions }) => (
  <CrosshairFrame className="cg-card mb-5">
    {(title || subtitle || headerActions) && (
      <div className="flex justify-between items-start px-6 py-4 border-b border-line">
        <div>
          {title && (
            <h3 className="font-['Archivo'] text-[18px] font-extrabold text-text">{title}</h3>
          )}
          {subtitle && (
            <p className="cg-label mt-1">{subtitle}</p>
          )}
        </div>
        {headerActions && <div className="ml-4">{headerActions}</div>}
      </div>
    )}
    <div className="p-6">{children}</div>
  </CrosshairFrame>
);

export default Card;
